module.exports = __webpack_public_path__ + "static/images/skinbg.d943fad.jpg";